<template>
  <div class="block_wrap">
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th scope="col">
              {{ translate('client.users.name') }}
            </th>
            <th scope="col">
              {{ translate('client.users.username') }}
            </th>
            <th scope="col">
              {{ translate('client.users.email') }}
            </th>
            <th scope="col">
              {{ translate('client.users.phone') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <a
            v-for="(user,key) in users"
            :key="key"
            @click.prevent="close_modal(user)"
            :href="pseudo_link(user)"
            class="user"
          >
            <tr class="pointer">
              <td :data-label="translate('client.users.name')">
                {{ user.name }}
              </td>
              <td :data-label="translate('client.users.username')">
                {{ user.username }}
              </td>
              <td :data-label="translate('client.users.email')">
                {{ user.email }}
              </td>
              <td :data-label="translate('client.users.phone')">
                {{ user.phone }}
              </td>
            </tr>
          </a>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Users',
  props: ['users'],

  data () {
    return {
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    pseudo_link(user){
      return '/usermanagment/users/@' + user.username
    },
    async close_modal(user){
      await this.cancel()
      await this.$router.push({path: '/usermanagment/users/@' + user.username})
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_clients{
    height: 100%;
    padding: 10px;
    &__header{
      height: 5%;
      .title{
        margin: 0;
        text-align: center;
      }
    }
    &__body{
      height: 88%;
      padding-right: 10px;
      overflow-x: hidden;
      overflow-y: scroll;
      .input_text {
        width: 100%;
        resize: none;
        outline: none;
        background-color: #fffcf5;
        border-radius: 4px;
        color: #66615b;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 100px;
        box-shadow: none;
        border: 1px solid #e8e8e8;
      }
    }
    &__footer{
      height: 5%;
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }
  .block_wrap{
    height: 100%;
    .response_table{
      padding: 0;
      table{
        tbody{
          .user{
            color: #333333;
            &:hover{
              tr{
                background-color: #eee;
              }
            }
          }
        }
      }
    }
  }



</style>
